"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpButtonStyle = void 0;
const typestyle_1 = require("typestyle");
exports.HelpButtonStyle = (0, typestyle_1.stylesheet)({
    container: { position: 'relative' },
    button: { fontSize: '20px', fontWeight: 'bold', textAlign: 'center', lineHeight: '18px' },
    panel: {
        position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: '340px', maxWidth: 'calc(100vw - 32px)', padding: '14px 16px',
        backgroundColor: 'rgba(8, 12, 20, 0.94)', border: '1px solid #536176', borderRadius: '6px',
        fontSize: '12px', lineHeight: '24px', boxShadow: '0 8px 28px rgba(0,0,0,0.65)', cursor: 'default', zIndex: 40,
        $nest: {
            '& > div:not(:first-child)': { display: 'flex', alignItems: 'center', gap: '5px' },
            '& b': { marginLeft: 'auto', color: '#d5dce8', fontWeight: 'normal' },
            '& kbd': { padding: '1px 5px', minWidth: '21px', textAlign: 'center', background: '#273243', border: '1px solid #56657a', borderRadius: '3px', fontFamily: 'monospace', color: '#fff', whiteSpace: 'nowrap' }
        }
    },
    heading: { color: '#fff', fontWeight: 'bold', borderBottom: '1px solid #4a5567', marginBottom: '5px', $nest: { '& span': { float: 'right', color: '#99a6ba', fontWeight: 'normal', fontSize: '10px' } } }
});
